export enum QuestionVariant {
	mcq = "MCQ",
	sata = "SATA",
	speaking = "speaking",
	writing = "writing",
}
